var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    questionBorderWidth: borders.widthSmall,
    questionBorderColor: colors.tiara,
    questionBorderRadius: borders.radiusMedium,
    titleColor: colors.ash,
    titleFontSize: typography.fontSizeLarge,
    questionPositionColor: colors.ash,
    itemBodyFontSize: typography.fontSizeMedium,
    itemBodyFontWeight: typography.fontWeightNormal
  };
};
export default generateComponentTheme;